import { render, staticRenderFns } from "./ProcesoCompraDiaAbonadoSga.vue?vue&type=template&id=33988464&scoped=true"
import script from "./ProcesoCompraDiaAbonadoSga.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcesoCompraDiaAbonadoSga.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProcesoCompraDiaAbonadoSga.vue?vue&type=style&index=0&id=33988464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33988464",
  null
  
)

export default component.exports